import DecimalForConceptos from "./DecimalForConceptos";
import DecimalAmount from "../../../../support/DecimalAmount";
import ConceptoBaseCalculator from "./ConceptoBaseCalculator";

class ComprobanteConceptoImpuestosCalculator {

  item = {}
  traslados = [];
  retenciones = [];

  constructor(item, traslados = null, retenciones = null) {
    this.item = item;
    this.traslados = traslados;
    this.retenciones = retenciones;
  }

  apply() {
    if (!this.traslados || this.traslados.length === 0) {
      return null;
    }

    const traslados = this._getTraslados();

    if (traslados.length === 0) {
      return null;
    }

    let impuestos = {
      Traslados: {
        Traslado: traslados
      }
    };

    const retenciones = this._getRetenciones();

    if (retenciones.length > 0) {
      impuestos.Retenciones = {
        Retencion: retenciones
      };
    }

    return impuestos;
  }

  _getTraslados() {
    let traslados = [];
    const base = (new ConceptoBaseCalculator(this.item)).get();

    for (const tax of this.traslados) {
      let traslado = {
        'Base': DecimalForConceptos.make(base).toFixed(),
        'Impuesto': tax.Impuesto,
        'TipoFactor': tax.TipoFactor,
        'TasaOCuota': DecimalAmount.make((tax.TasaOCuota || 0)).toFixed(6),
        'Importe': DecimalForConceptos.make(base * (tax.TasaOCuota || 0)).toFixed()
      };

      if (tax.TipoFactor === 'Exento') {
        delete traslado.TasaOCuota;
        delete traslado.Importe;
      }

      traslados = traslados.concat([traslado]);
    }

    return traslados;
  }

  _getRetenciones() {
    let retenciones = [];
    const base = (new ConceptoBaseCalculator(this.item)).get();

    for (const tax of this.retenciones) {
      let traslado = {
        'Base': DecimalForConceptos.make(base).toFixed(),
        'Impuesto': tax.Impuesto,
        'TipoFactor': tax.TipoFactor,
        'TasaOCuota': DecimalAmount.make((tax.TasaOCuota || 0)).toFixed(6),
        'Importe': DecimalForConceptos.make(base * (tax.TasaOCuota || 0)).toFixed()
      };

      if (tax.TipoFactor === 'Exento') {
        delete traslado.TasaOCuota;
        delete traslado.Importe;
      }

      retenciones = retenciones.concat([traslado]);
    }

    return retenciones;
  }
}

export default ComprobanteConceptoImpuestosCalculator;